export const business = [
    {
        id: "content-business-latest-trends",
        name: "最新のトレンド",
        articles: [
            {
                id: "addec243-95e5-4aae-8261-c6b82b928293",
                class: "columns-3-wide",
                header: "投資",
                url: "#",
                carousel: {
                    width: "684",
                    height: "385",
                    images: [
                        {
                            id: "038a6c60-3006-470b-9d93-323c1c585cf7",
                            src: "assets/images/maxim-hopman-IayKLkmz6g0-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "25d59bcd-4740-48d3-921d-d4856317a848",
                            src: "assets/images/joshua-rawson-harris-KRELIShKxTM-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "58880bc6-deea-46fc-8637-02f515e81469",
                            src: "assets/images/martin-sanchez-z2v23KWm5D0-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "28b22171-338a-4ada-b87e-84a7bb42c3a3",
                            src: "assets/images/nasa-1lfI7wkGWZ4-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        {
                            id: "2587289d-eece-4001-b39e-aecfbd4a4253",
                            src: "assets/images/thomas-scott-yASysTwq-Is-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                    ],
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                    tag: {
                        type: "breaking",
                        label: "速報",
                    },
                },
            },
            {
                id: "4d5bbeee-9e05-4f95-b6bf-af41b145e4e3",
                class: "columns-3-narrow",
                header: "メディア",
                url: "#",
                image: {
                    src: "assets/images/glenn-carstens-peters-npxXWgQ33ZQ-unsplash_336.jpg",
                    alt: "プレースホルダー",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "ウォームアップとケアで妊娠しています。大規模なチップまで、メインロレムでのさまざまな宿題。",
                type: "text",
                content:
                    "どの学部生活が再開される控除可能な場合。しかし今、彼はサッカーのメンバーになりたいと思っています。醜い今はロアムの痛みが必要ですが。バナナフェリーパッチはないからです。あなたまで写真とサッカー。最新のサラダのエコロジーサッカー開発者プロパガンダは時々望んでいます。今の人生のチャンピオンですが、要素の弓の要素.",
            },
            {
                id: "a788ad50-9e3a-461e-be18-828fbce1dbd9",
                class: "columns-3-narrow",
                header: "洞察",
                url: "#",
                image: {
                    src: "assets/images/kenny-eliason-4N3iHYmqy_E-unsplash_336.jpg",
                    alt: "プレースホルダー",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "粘着性ポットが今走っています。重要なのは、開発者の宿題の悲しいケアです。",
                type: "text",
                content: "学部生が悲しい笑顔までまたは。または生態学的なullamCorperには資産さえもファシリシは必要ありません。人生とライオンの宿題は、よりも直径として。また、プールマッサージの喉をプッシュすることは、時々ロレムを設定します。",
            },
        ],
    },
    {
        id: "content-business-market-watch",
        name: "マーケットウォッチ",
        articles: [
            {
                id: "ed902471-e96d-462b-bc88-01c7e22d5fa0",
                class: "columns-3-balanced",
                header: "トレンド",
                image: {
                    src: "assets/images/anne-nygard-tcJ6sJTtTWI-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "各矢印唐辛子ニンジン",
                type: "text",
                content:
                    "車両の大きな要件の痛み。ニブ・ニンジンの利便性FAFILISIリレーなし。プールマッサージのあごにさえ時々。キャリアスキームを置きます。マスは、パッケージの注文の不動産では現在価値がありません。ジャスミンのモーリス範囲を計画するか。現在のタンク。",
            },
            {
                id: "31a8663a-d035-4b62-adeb-195a1c60e831",
                class: "columns-3-balanced",
                header: "技術",
                image: {
                    src: "assets/images/truckrun-XBWF6_TEsFM-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "臨床的ソリシジンをキャリアまたは犯罪させます。",
                type: "text",
                content:
                    "現在の元素抗酸化物質ライオンまたは生態学的なウルラムコルパー。いくつかのサラダ生態学のチョコレート漫画モーリス。残念ながら、長い間嫌いです。アルコールをベッドするためのサッカーのプロパガンダ。プレイヤーの時点での直径の、私はとてもよく。",
            },
            {
                id: "bf9491d2-ffcc-4ed3-a3a4-2cfda792f06b",
                class: "columns-3-balanced",
                header: "成功",
                image: {
                    src: "assets/images/alex-hudson-7AgqAZbogOQ-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "ドゥイの喉のチョコレート発酵。",
                type: "text",
                content:
                    "バレーボール栄養居住者サッカー悲しい老年。大きく均等なタイムオルシ。ニンジンはファシリシ移民車両をお願いします。チリテイストフットボールマッサージの温度ですが、まだプールだけです。マウス・マウリス・ヴィトー・ウルトリシーズ・ライオン。",
            },
        ],
    },
    {
        id: "content-business-economy-today",
        name: "今日の経済",
        articles: [
            {
                id: "95d5859b-44d0-452b-adba-52af428c9b8e",
                class: "columns-wrap",
                header: "グローバルな影響",
                type: "excerpt",
                content: [
                    {
                        id: "1f074185-0c72-47cc-b889-2b0d5be855eb",
                        image: {
                            src: "assets/images/chris-leboutillier-TUJud0AWAPI-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "今、人生のチャットのアルコールライフ要素を飲みますが、。非常に喉のライフ調査またはです。週末は無料ですが、明日のサッカーはです。ですが、シナリオではバナナを引きます。",
                    },
                    {
                        id: "5ba10ec7-2031-4e61-98c4-4fa2e681c0e2",
                        image: {
                            src: "assets/images/nasa-Q1p7bh3SHj8-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "チャンピオンシップは、カメラのそれぞれよりも多様な学者です。しかし、笑顔は、臨床サッカーカートンでの必須の抗酸化物質。整数には多くの興味深いものが必要です.",
                    },
                    {
                        id: "8534ba50-7daa-43da-ab5e-929b06ee127f",
                        image: {
                            src: "assets/images/markus-spiske-Nph1oyRsHm4-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "地域の笑い声で学部生。サッカーの時間ターゲットポット。の週末は、抗酸化物質が最大のニンジンを嫌います。エレメントフットボールの抗酸化物質のライオンポットの従業員。",
                    },
                ],
            },
            {
                id: "f89eb533-713d-4ece-9998-c29672199357",
                class: "columns-wrap",
                header: "見通し",
                type: "excerpt",
                content: [
                    {
                        id: "c9e71431-0407-4329-bbb3-61a820dc636a",
                        image: {
                            src: "assets/images/denys-nevozhai-z0nVqfrOqWA-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "今、ソフトでソフトなプレイヤーになるために。バイヤー最大の震えとバスケットボールまたはデッキジャスミン。シットチケットを妊娠するグレートニンジーチリ。",
                    },
                    {
                        id: "d0c42c8e-e4a5-46b7-a7a7-9e3e8dfb34a3",
                        image: {
                            src: "assets/images/taylor-grote-UiVe5QvOhao-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "今、サッカー選手、私の喉の人生のバナナまたはウラムコーパー。漫画のバナナは明日たくさんの楽しみが必要です。レシピIDゲートニブが滅菌されました。そして、私は子供たちの直径の週末の便利さを嫌うまでサッカーですが。",
                    },
                    {
                        id: "c3bbf9c0-e133-405b-8a1b-e24da3258980",
                        image: {
                            src: "assets/images/linkedin-sales-solutions--AXDunSs-n4-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "モンテスは、マウスの最大のヴィタエウリシーズライオンで生まれることができます。ストリートの種類 範囲の栄養開発者。",
                    },
                ],
            },
            {
                id: "eb628ced-8e49-4cc7-a4b6-2531bc5f7b30",
                class: "columns-wrap",
                header: "経済的自由",
                type: "excerpt",
                content: [
                    {
                        id: "bc0da085-5ade-493d-8784-78ae2607cf29",
                        image: {
                            src: "assets/images/tierra-mallorca-rgJ1J8SDEAY-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "今、人生のチャットのアルコールライフ要素を飲みますが、。震えまたはチケットは現在、ロアムの痛みが必要ですが。製造レクサスモーリスバスケットボールピーナッツ。震えとバスケットボールまたはデッキジャスミン。",
                    },
                    {
                        id: "9ae84ec2-229d-4969-870a-23e8561146ef",
                        image: {
                            src: "assets/images/stephen-phillips-hostreviews-co-uk-em37kS8WJJQ-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "現在、妊娠中の抗酸化物質や谷の調査飲み物です。しかし、地域では、整数チョコレートバリエッドサッカー。生命が地域の最大のaを受け取る場合。",
                    },
                    {
                        id: "8b9e5c03-b566-4e78-9df3-768698a17713",
                        image: {
                            src: "assets/images/roberto-junior-4fsCBcZt9H8-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "しかし、アルコールは嫌われていません。臨床は、マイクの価格漫画を作ってください。チュートリアルプレーヤー。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-must-read",
        name: "必読",
        articles: [
            {
                id: "b77172cc-4e49-40ca-9235-eb2f5f865804",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "75dba799-f4f1-43d7-909c-81e107a61281",
                        image: {
                            src: "assets/images/carl-nenzen-loven-c-pc2mP7hTs-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "病気のようなサラダ生態学のチョコレート漫画モーリス。オールドアンドネトゥスとマレスアダの飢erと醜い法執行機関。スマイル漫画のマクロ。今はサッカーですが、プロパガンダ車は人生の宿題を引きます。バナナフェリープールの嘆き層はありません。",
                        url: "#",
                    },
                    {
                        id: "7d882247-3db1-4882-a609-ee5eed6dc6df",
                        image: {
                            src: "assets/images/devi-puspita-amartha-yahya-7ln0pST_O8M-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "人生には素晴らしいウォームアップが必要です。またはピーナッツティルと憎しみの時間タンパク質。週末は、あなたが憎しみの弓を飾りたい願いです。重要であることが重要です。飲み物は、マネージャー全体のウルトリシーです。",
                        url: "#",
                    },
                    {
                        id: "de04fa72-d96e-4eb7-bbf7-d587e31a5f6b",
                        image: {
                            src: "assets/images/bernd-dittrich-Xk1IfNnEhRA-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "はそうです。メインロレムでは、大量のサピエンの喉とテレビまで。常にビューローの妊娠中の化粧に微笑んでください。マグナの推定ニブが必要です。",
                        url: "#",
                    },
                    {
                        id: "d6275634-2236-4a3c-b787-a71d33ae5bdf",
                        image: {
                            src: "assets/images/crystal-kwok-xD5SWy7hMbw-unsplash_448.jpg",
                            alt: "プレースホルダー",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "妊娠局は卒業しました。週末には、恐怖のフットボールの滅菌地域としての直径。。サッカーの醜い法執行機関の価格ジャスミンは素晴らしい。臨床フットボールカートンエレメント。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-educational",
        name: "教育",
        articles: [
            {
                id: "4187d9c9-e176-4b0a-8bee-03f4f3be418a",
                class: "columns-3-balanced",
                header: "ビジネス101",
                image: {
                    src: "assets/images/austin-distel-rxpThOwuVgE-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "各矢印唐辛子ニンジン。",
                type: "text",
                content:
                    "卒業したデッキへのインシデントDUI。直径の変数である男性。学部生の悲しい笑顔またはEUまでの重要な直径。ニンジンコース。スカート任意またはピーナッツのティルと憎しみ。マクロセットをレイヤーし、結果としてこれまでに。顧客の顧客を育てた顧客を置くこともあります。ローレム今または笑顔の便利な漫画。チャンピオンシップは、各直径よりも多様な学者です.\n\nあなたがいつも選んでからずっと人生の素晴らしい開発者のために。カートンチョコレートの しかし、時間はurと震えの塊です。",
            },
            {
                id: "c519abd4-bb39-4b35-b3fb-130713f8f27b",
                class: "columns-3-balanced",
                header: "起動",
                image: {
                    src: "assets/images/memento-media-XhYq-5KnxSk-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "臨床的ソリシジンをキャリアまたは犯罪させます。",
                type: "text",
                content:
                    "唐辛子の強力なマクロ寿命。バルプタートMIニンジンが始まります。サッカーサッカーの開発者居住者。栄養大衆不動産宿題の補償。明日の温かい憎しみサッカ価格自体。フットボールフットボールアローはサッカーを矢にしています。執行環境の環境栄養補助控除可能。非直径ナム製造ロレムセッド笑い。フットボールチョコレートトリガーヘアスタイル.\n\n素晴らしいと不動産製造。ロボルティスEUはプロパガンダに住んでいます。酵母のは鍋に置かれているかどうか。サッカー開発者サッカーのマスニーズ。は、栄養開発者のサッカーです。",
            },
            {
                id: "a7b41785-e2d9-4afa-a161-5edcffce77a8",
                class: "columns-3-balanced",
                header: "利益を上げます",
                image: {
                    src: "assets/images/austin-distel-97HfVpyNR1M-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "ドゥイの喉のチョコレート発酵。",
                type: "text",
                content:
                    "上記の範囲の通りのこのコースの地球。今、ターゲットを絞って、私の喉の寿命バナナまたは。チョコレートを除くプレイヤーにチリの漫画層が必要です。フィルムバレーは、時々を嘆願します。チョコレートチリのバスケットボール射撃臨床。はプロパガンダに住んでいます。ウルトレイシーはバナナを悲しさせません。ニブ・モーリスレーシングマティステレビ栄養をターゲットにした.\n\n要素サッカーの抗酸化物質は病気が嫌いです。そして、醜い執行整数はバナナ・ニーブ・プレゼントが悲しい偉大なものを必要としています。この地域の笑い声を上げている怪物。",
            },
        ],
    },
    {
        id: "content-business-underscored",
        name: "強調されています",
        articles: [
            {
                id: "4e229873-04c6-410a-a433-18178fa4aad5",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "a623eb53-c205-4ba7-88cc-7d28a402fbe7",
                        image: {
                            src: "assets/images/bruce-mars-xj8qrWvuOEs-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "病気のようなサラダ生態学のチョコレート漫画モーリス。オールドアンドネトゥスとマレスアダの飢erと醜い法執行機関。スマイル漫画のマクロ。今はサッカーですが、プロパガンダ車は人生の宿題を引きます。バナナフェリープールの嘆き層はありません。",
                        url: "#",
                    },
                    {
                        id: "5a406442-2994-47c1-9e9c-51ccb2c12dbc",
                        image: {
                            src: "assets/images/ryan-plomp-TT6Hep-JzrU-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "人生には素晴らしいウォームアップが必要です。またはピーナッツティルと憎しみの時間orciタンパク質。週末は、あなたが憎しみの弓を飾りたい願いです。重要であることが重要です。飲み物は、マネージャー全体のウルトリシーです。",
                        url: "#",
                    },
                ],
            },
            {
                id: "1760d2cf-9530-4c27-9943-ec0525b5dd4f",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "12d94ea1-157a-4f3d-87bf-28c305b52aea",
                        image: {
                            src: "assets/images/robert-bye-xHUZuSwVJg4-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "病気のようなサラダ生態学のチョコレート漫画モーリス。オールドアンドネトゥスとマレスアダの飢erと醜い法執行機関。スマイル漫画のマクロ。今はサッカーですが、プロパガンダ車は人生の宿題を引きます。バナナフェリープールの嘆き層はありません。",
                        url: "#",
                    },
                    {
                        id: "8f623500-fbd4-4bc0-9a72-31b7c18749a8",
                        image: {
                            src: "assets/images/jay-clark-P3sLerH3UmM-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "人生には素晴らしいウォームアップが必要です。またはピーナッツティルと憎しみの時間orciタンパク質。週末は、あなたが憎しみの弓を飾りたい願いです。重要であることが重要です。飲み物は、マネージャー全体のウルトリシーです。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-investing-101",
        name: "投資101",
        articles: [
            {
                id: "d3b35a69-8fa6-49b6-a86f-a451e15430f0",
                class: "columns-3-balanced",
                header: "資産を管理します",
                type: "articles-list",
                content: [
                    {
                        id: "d7e4b0d6-79f6-4ee0-9a25-07948eb0f199",
                        title: "すべてのプレイヤーですが、妊娠温度で滅菌された大きなパフォーマンス。",
                        content:
                            "チョコレートチリには常に宿題が必要です。ソーススカートとピーナッツのティルと憎しみ。臨床の価格は、プルマッサージの代替価格を作成してください。チョコレートのチョコレートでもありました。それは資金調達の不動産でしたが、でした。強力なものとマクロの唐辛子の顎。",
                    },
                    {
                        id: "e1c56eba-491c-461f-85dd-a3df520dfbfc",
                        title: "著者でない限り、カートンの製造。特定の著者の境界線を一時停止します。",
                        content: "は、サッカーの直径でさえもファシリシを必要としません。フットボールのサッカーは直径栄養価が高い。私はジャスミンが嫌いですが、学部の直径まで。または飲み物の矢印までのティーンエイジャー。",
                    },
                    {
                        id: "3b46da4b-dd8e-49fd-b53f-64effe759dea",
                        title: "モーリスの臨床をお願いします。抗酸化物質または大きなサッカーの震えを強調します。",
                        content: "残念ながら、私は栄養の直径の週末が嫌いです。しかし、無料ですが、サッカーの醜い喉。従業員は明日温かい憎しみサッカーの価格。ウォームアップの悲しい笑顔または。ライオンポットの病気を設定するための醜い執行。",
                    },
                ],
            },
            {
                id: "27a697e9-74a9-459c-9cd2-d479d65ac2f7",
                class: "columns-3-balanced",
                header: "何を見るか",
                type: "articles-list",
                content: [
                    {
                        id: "c1d78742-406a-4123-86cd-bc4fad85f28b",
                        title: "全体または週末の要素。",
                        content:
                            "カートンチョコレートであるサッカーの直径。しかし、プールですが、アークはパフォーマンススカートを1つでも嫌いではありません。はそれぞれを飲むか欲しいです。チャンピオンシップライブアルコールトリガードリンクとしてタンク。ミネアポリスの学部開発者は、滅菌した唐辛子のニンジンを滅菌します。",
                    },
                    {
                        id: "01ca72c3-7112-4a57-9173-a527977755ae",
                        title: "人生の醜い質量ですが、時間のバニーの要素。",
                        content:
                            "サッカーカートンの要素ニブ漏斗。ARCランニングパフォーマンスメールで各執行の直径を貸し出します。純粋は現在の元素抗酸化物質ではありません。地域のモーリスに直径を伝える可能性がありますが、SEMの場合。しかし、バニーの要素ですが、笑顔の価格。",
                    },
                    {
                        id: "7734f54b-5b1b-4a6f-b81a-b15b0f0d52cb",
                        title: "あなたがあなたの栄養の直径を嫌うまでレシピとトリガー。",
                        content: "ナビゲーションの直径ニンジンプレイヤーは学部の飲み物を受け取ります。はまたはDeckに従います。サッカーの悲しい老人とネタスの住民。学部生活として控除可能。空腹と醜い執行セット病。",
                    },
                ],
            },
            {
                id: "cff3dc12-6773-4f70-a22d-ff1bc100c818",
                class: "columns-3-balanced",
                header: "知ってますか？",
                type: "articles-list",
                content: [
                    {
                        id: "379fa367-cf87-4b0a-8ab6-1a0b1a8d7943",
                        title: "パッチが領域を引き込みます。電子レンジが必要ですが、無料です。",
                        content: "直径があります。製造栄養開発者の範囲。恐怖は、便利なクマの時に言った。には、サッカーの直径でさえもファシリシは必要ありません。には​​、トマト唐辛子の環境矢印のゲームが必要です。",
                    },
                    {
                        id: "508c1266-d70f-4e9d-ae5f-fab87fccc1a0",
                        title: "顧客のニンジンがあります。宿題のウルトレシープールですが、醜い開発者。",
                        content: "ジャスミンは嫌いですが、顧客まで学部の直径。は割れ目に注意しません。大量のサピエンの喉まで、メインロレムでさまざまな宿題でした。",
                    },
                    {
                        id: "b3fa7b41-ed86-4ab1-a86a-21283741d1a0",
                        title: "航空会社の大量IDなしよりも直径としての。",
                        content:
                            "明日サッカーアークドゥイライブ。は選択された製造業です。老人とネタスとマレスアダの飢えと醜い。キャリアがない限り、モーリスは今宿題です。私はバッテリーアークとマクロサッカーのコンバリスとジャスミンをチャットしません。ライオンよりも選ばれた人の価格。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-stock-market",
        name: "株式市場",
        articles: [
            {
                id: "49e01dcc-39fd-482d-b0c1-31918f791041",
                class: "columns-wrap",
                header: "ダウ・ジョーンズ",
                type: "excerpt",
                content: [
                    {
                        id: "a9ae906b-e98d-412d-89a1-baba39c0be01",
                        image: {
                            src: "assets/images/annie-spratt-IT6aov1ScW0-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "臨床の価格は、マクロ価格のプルローションを作成してください。チョコレートバスケットボールのキャリア著者のチップのキャリア著者なら。寿命マクロソースラシニアの必須ミサ1つ以上。ランニングパフォーマンスメールで。",
                    },
                    {
                        id: "217c58fc-0edf-417d-9305-4abc0615eef8",
                        image: {
                            src: "assets/images/tech-daily-vxTWpu14zeM-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "タイムポットと震えの質量ウルトレシー。製造ロレムセッドスマイルウルトレイシーサッドバナナ。大きな生態学的な鍋で卒業した多くの喪の滅菌。",
                    },
                    {
                        id: "82606dff-6bc4-4b84-b0d8-c7557f6482e4",
                        image: {
                            src: "assets/images/markus-spiske-jgOkEjVw-KM-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "地域整数チョコレートバリエッドサッカーの漫画学部。一度に質量または臨床IDのfeugiat nisl価格。いくつかの唐辛子ニンジンの喪を着るための投資。",
                    },
                ],
            },
            {
                id: "084674ba-b34b-4841-8674-e29bfd3633fa",
                class: "columns-wrap",
                header: "S＆P 500",
                type: "excerpt",
                content: [
                    {
                        id: "2c06041f-b0b4-47f3-a1c4-ab3fb25f0803",
                        image: {
                            src: "assets/images/boris-stefanik-q49CgyIrLes-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "直径のそれぞれよりも多様な笑い。バスケットボールでの笑い私の時間のマルスアーダの資金調達。OKの著者のマクロ。と予約済みのマイクロ波無料。今、プロパガンダ車はライフの宿題を引きます。",
                    },
                    {
                        id: "b408a578-0fda-4423-9635-cbf1c2aa675d",
                        image: {
                            src: "assets/images/m-ZzOa5G8hSPI-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "各の直径またはバレーボールの要素はそうではありません。は妊娠したアークとマクロサッカーバレーをチャットしません。そして、レシピが常に無料療法のために引っ張るので。",
                    },
                    {
                        id: "635b4368-112d-4062-8e8c-e95171cffa6f",
                        image: {
                            src: "assets/images/matthew-henry-0Ol8Sa2n21c-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "プッシュは、喉をマッサージし、時にはロレムをセットアップするよりもそれほど大きくありません。抗酸化物質の場合、妊娠または谷。このコースにチケットを座る人。",
                    },
                ],
            },
            {
                id: "d287a7b5-305f-4e6f-81c7-3a6f1e833a5a",
                class: "columns-wrap",
                header: "デイトレーディング",
                type: "excerpt",
                content: [
                    {
                        id: "5a5482c2-f4ef-4cca-98b4-1e6cdca39ec5",
                        image: {
                            src: "assets/images/dylan-calluy-j9q18vvHitg-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ペレンテスクのバレーボール栄養居住者サッカー悲しい古いオールドとネトゥスと。ただし、サラダがバナナのegetを引くように。門脈プールの嘆き層温度。あなたが直径になるまで多くの治療。",
                    },
                    {
                        id: "f6fa61d0-5086-445c-8192-9f78ce2c3a63",
                        image: {
                            src: "assets/images/yucel-moran-4ndj0pATzeM-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ニブ・ニンジンの利便性ファシリシ移民車両はありません。は醜い塊を走らせます。生態学的な栄養価の高い熱控除価格まで。しかし、学部生の悲しい笑顔またはが入るまで、学部生の直径。",
                    },
                    {
                        id: "f3f5f6b2-cdcf-49b6-b650-bb80c9459dde",
                        image: {
                            src: "assets/images/stefan-stefancik-pzA7QWNCIYg-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "結果として、モーリスはキャリアを除いて宿題になります。しかし、私は笑顔の非難の週末が嫌いです。特定の製造サッカーではない航空会社の大衆よりも直径。整数のライフセラピーには、大規模なウォームアップフットボールが必要です.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-impact",
        name: "影響",
        articles: [
            {
                id: "f87f6f06-2480-48b1-abf0-17c97fa92d27",
                class: "columns-3-balanced",
                header: "石油危機",
                type: "articles-list",
                content: [
                    {
                        id: "f452479c-6084-4b57-925d-a7851a0a1211",
                        title: "栄養メンバー、サッカーニーズ、生態学的ニブ。",
                        content: "重要なことは、飲酒は全体の補償です。非常に今、バナナは妊娠中の抗酸化物質のために飲みます。正面にストレス。常に子供たちよりも常にオクターまたはキャリア期間。のトーマスは、地域の整数の学部生をプルします。",
                    },
                    {
                        id: "1caebfb3-912b-485d-a4b7-4500adb5066a",
                        title: "可能な限り控除可能な場合を除き、サッカージャスミンのパフォーマンス要素。",
                        content:
                            "ジャスミンの価格は大きくなり、。直径ニンジンプレイヤーはボクシングドリンクを受け取ります。当時の寿命も、栄養や一部のサラダのどちらでもありません。強力なほとんど、および唐辛子の顎の温度。非常に今、バナナは妊娠中の抗酸化物質のために飲みます。",
                    },
                    {
                        id: "341d9b4b-d3eb-4728-922e-222d745665c1",
                        title: "チリからのバスケットボール射撃臨床。中性ニュートラル中性ニュートラル中性。",
                        content:
                            "プロパガンダの必要性はさまざまです。トラックのニブは悲しいことを提示します偉大な人は妊娠する重要な唐辛子です。要素をからかうための不動産。直径のケア時間フットボール選手は今ではです。どちらのバスケットボールも私の電子レンジをエジットしません。あらゆる笑顔でパフォーマンススカートが嫌いです。",
                    },
                ],
            },
            {
                id: "8d0c8045-a260-47ec-9f28-1098d994da86",
                class: "columns-3-balanced",
                header: "ハイテク市場",
                type: "articles-list",
                content: [
                    {
                        id: "40e13034-8351-4f8a-8e1d-3d6f068e6709",
                        title: "たくさんいることが重要です。への直径のvulputateがあるまで。",
                        content: "抗酸化物質や妊娠のために飲む。はプロパガンダに住んでいます。著者または子供としての人生期間または。への直径の滑が重要になるまで。最新のサラダのエコロジーサッカー開発者プロパガンダは時々望んでいます。",
                    },
                    {
                        id: "2b763d78-1424-4a2e-a5a2-79fe02253600",
                        title: "大量のウリシーズ、消費者のマグナ・イーゲットをヘンドレリットする私の男。",
                        content: "痛みの質量は、プレイヤーの唐辛子漫画層を執行する必要があります。人生の最大の範囲のコースのスケジュール。妊娠アークとマクロジャスミンと温度。楽しみのために滅菌されるキャンペーン。",
                    },
                    {
                        id: "3d29bcd8-9d18-4dac-8f98-197c968f90bd",
                        title: "大量のサピエンの喉まで主要なロレムでの力。",
                        content: "明日の著者から妊娠または谷または。ニンジンになるのは多くの時間です。病気のライオンポットの従業員をサッカーの要素に置いてください。デート製造範囲の栄養範囲のこの通りのこのコースの地球。",
                    },
                ],
            },
            {
                id: "9144e1b3-46b1-4c71-b26d-6f4cf74e7444",
                class: "columns-3-balanced",
                header: "市場の減少",
                type: "articles-list",
                content: [
                    {
                        id: "4887a57f-dee5-4023-a173-bcb2a691f6ca",
                        title: "私はジャスミンが嫌いですが、学部生の悲しい笑顔まで学部生の直径が嫌いです。",
                        content: "またはチケットが今必要です。他のすべての人がIDであるように整合している笑顔の弓を取らないでください。さまざまなまたは震えでアルコール飲み物を寝かせるプロパガンダまたは。のコンセラプッシュは現在の要素ではありません。",
                    },
                    {
                        id: "73bd8127-50e4-44e7-836d-07e330226717",
                        title: "カートンチョコレート発酵です。フェリスには、希望のバナナの矢が必要です。",
                        content:
                            "どちらのDUIもそのための不動産ではありません。現在、喪に服している滅菌された段階的な大規模な生態学的なポット航空会社の痛みの範囲。しかし、ビートMIニンジンモーリスの利便性。プールですが、醜い開発者 調査。デートの製造範囲の通りのこのコースで.",
                    },
                    {
                        id: "a585ea07-caf5-44b9-88d2-f8f5f8ae6f02",
                        title: "ランディットはバスケットボールで笑いを走り、私の時間はマレスアダではありません。",
                        content:
                            "人生には、大きなウォームアップワークのサッカーが必要です。直径はありません。そして、マレスアダの飢えと醜い。サッカーでは、私の飲み物や宿題が欲しい。大きなウォームアップのサッカーまたは直径が必要です。しかし、枕マイクロ波妊娠局は卒業しました。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-hot-topics",
        name: "ホットな話題",
        articles: [
            {
                id: "1e60235c-0198-4448-9267-f3f86542d7dc",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "7498eaec-d8dc-442f-b939-2bff86ed2c6e",
                        image: {
                            src: "assets/images/alice-pasqual-Olki5QpHxts-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "質量またはfは、ゼロです。ケアと臨床的ナグ執行テロメイクアップ地域の栄養。またはいくつかのの矢印。この映画は、執行の不動産であり、まだ資金調達されていました。ですが、",
                        url: "#",
                    },
                    {
                        id: "cce7d8eb-b0d7-40a6-bc7d-932ac420fd43",
                        image: {
                            src: "assets/images/lukasz-radziejewski-cg4MzL_eSvU-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "パフォーマンスは、を引きます。モーリス栄養バレーボール栄養居住者サッカー悲しい老年。はアルコールライフエレメントチャットライフを飲みます。臨床IDは温度を取ってください。",
                        url: "#",
                    },
                ],
            },
            {
                id: "46e89da3-b39c-43a7-9178-efeeb91e973d",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "40389294-8c93-4c5a-8a63-57ffefdd8f89",
                        image: {
                            src: "assets/images/microsoft-365-f1zQuagWCTA-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "チョコレートトリガーファイナンスマイクロ波発酵ライオンまたは臨床。チリジョーズフットボールマッサージの温度、それだけです。エレメントフットボールの抗酸化物質での痴漢ですが、嫌いです。栄養ニンジンの航空会社が必要です。サッカープロパガンダの著者の人生は、さまざまなものでアルコール飲み物をベッドします。",
                        url: "#",
                    },
                    {
                        id: "bb50d294-0aaa-40c1-aebd-f727bc270b17",
                        image: {
                            src: "assets/images/emran-yousof-k8ZbMQWbx34-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "バニーですが、スマイルの価格は、スマイツサッカーマッサージよりも。強力なヌラとサッカーの唐辛子の温度。現在、不動産は、地域の要素が生命とライオンの矢印を矢印することです。ペレンテスクのバレーボール栄養居住者サッカー悲しい老年。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-business-paid-content",
        name: "有料コンテンツ",
        articles: [
            {
                id: "d6c99f00-e45b-4da3-abb8-2a0a3bd27cc7",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "d9326d57-6280-4f00-a047-12be65eb3ca2",
                        image: {
                            src: "assets/images/junko-nakase-Q-72wa9-7Dg-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "ファシリシス素晴らしい、臨床サッカーカートン要素ニブ地域でさえ。サッカーは現在、キッズニンジンの革新的なの喉です。",
                    },
                    {
                        id: "bbe374d2-6058-4800-8ecb-2101785ba463",
                        image: {
                            src: "assets/images/heather-ford-5gkYsrH_ebY-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "モーリスレンジジャスミンまたは開発者を走るローン。バスケットボールまたはフットボールのジャスミンのパフォーマンス要素はない限り。当時のアンティのバナナEU。",
                    },
                ],
            },
            {
                id: "2b905eee-c666-4704-9658-1e0757b02253",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "e84ec76b-e0ec-4477-adcd-3a7f49516895",
                        image: {
                            src: "assets/images/metin-ozer-hShrr0WvrQs-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "メーセナの直径の多く。大きなニンジン唐辛子妊娠中心。笑い声とサッカーの必要は今ありません。そして、私は子供たちの直径の週末の便利さを嫌うまでサッカーですが。",
                    },
                    {
                        id: "f5cddda2-e658-4f4f-b245-33228dad3eb3",
                        image: {
                            src: "assets/images/mac-blades-jpgJSBQtw5U-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "メキシコのサッカーマッサージの顎はパッチのみです。今マレスアダか、または微笑む便利さ。臨床IDの価格は、マクロ価格のプルローションを作成してください。",
                    },
                ],
            },
            {
                id: "1acc8fc3-74bb-46b0-8d67-bee9bfb7667a",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "41f2e683-c165-4573-a50d-27aad4deae11",
                        image: {
                            src: "assets/images/keagan-henman-xPJYL0l5Ii8-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "ドリンクアルコールライフエレメントチャット。キッズニンジン航空会社の機能的なスマート病はそうではありません。",
                    },
                    {
                        id: "8249c70b-245f-44e4-829e-d08a273522c7",
                        image: {
                            src: "assets/images/erik-mclean-ByjIzFupcHo-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "ポットの著者のマイク、それは一部の恐怖のコースです。facilisis大きく均等なタイムオルシ。今、サッカー選手、私の非常に喉の人生のバナナ。",
                    },
                ],
            },
            {
                id: "a005c941-9e4b-4219-88df-d6a553b3c237",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "1d5eee05-b406-4853-b5ba-f37728062b2e",
                        image: {
                            src: "assets/images/ixography-05Q_XPF_YKs-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "製造業は、政権執行補償としてピーナッツを強化しました。存在しませんが、いくつかのライオン門の悲しみのライオン.",
                    },
                    {
                        id: "66f72ca0-97b1-48f1-9aa5-ad53f4d040d5",
                        image: {
                            src: "assets/images/harley-davidson-fFbUdx80oCc-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "アリウスサッカーは現在、キッズニンジン航空会社の喉です。無料の週末は座っていますが、明日。しかし、今はバナナを飲みます。",
                    },
                ],
            },
        ],
    },
];
